import React, { useState } from "react";
import "../style.css";

const photos = [
  { image: "https://shrikashidham.com/wp-content/uploads/2023/08/1-3.jpg" },
  { image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTh_CsGcyKv56elqQtBW7KTOdm-0Sajp066WA&s" },
  { image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Manikarnika_Ghat%2C_Varanasi%2C_Uttar_Pradesh%2C_India_%282011%29_5.jpg/1200px-Manikarnika_Ghat%2C_Varanasi%2C_Uttar_Pradesh%2C_India_%282011%29_5.jpg" },
  { image: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2d/cd/2f/31/caption.jpg?w=1200" },
  { image: "https://static-bestcolleges.tosshub.com/2025/News/ENmSwY5ZhEMlJ3niJxlWsh7Wpz6oErE4TXInNrzp.jpg" },
  { image: "https://s7ap1.scene7.com/is/image/incredibleindia/ramnagar-fort-varanasi-2-attr-hero" },
  { image: "https://img.avianexperiences.com/trek/2d3f1914-76ba-492d-a875-f90361caaaa7" },
  { image: "https://upgiants.com/wp-content/uploads/2025/04/Triveni-Sangam-1024x576.webp" },
  { image: "https://srjbtkshetra.org/wp-content/uploads/2020/11/Cam_04_01_Comp.jpg" },
  { image: "https://cdn1.tripoto.com/media/filter/tst/img/2198413/Image/1680410110_namo.jpg.webp" },
  { image: "https://www.daiwikhotels.com/wp-content/uploads/2024/07/kashi-temple-inside1-3-1.jpg" },
  { image: "https://indiano.travel/wp-content/uploads/2022/07/View-of-the-Shri-Vishwanath-Temple-Shri-Vishwanath-Mandir.-The-swastika-on-the-tower-is-in-Hinduism-considered-an-holy-symbol-used-on-all-possible-occasions.jpg" },
];

const videos = [
  { title: "Ganga Aarti – Dashashwamedh Ghat", videoId: "dV8X4N9YF4E" },
  { title: "Varanasi Spiritual Vibes", videoId: "R4UeR4j2Z9E" },
  { title: "Kashi Vishwanath Corridor", videoId: "1qU5n2U7Zt8" },
];

const Gallery = () => {
  const [activeTab, setActiveTab] = useState("photos");
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="gallery-section">
      <div className="gallery-container">

        {/* Header */}
        <div className="gallery-header">
          <h2>Visual Experience</h2>
          <p>
            Moments In <span>Varanasi.</span>
          </p>
        </div>

        {/* Tabs */}
        <div className="gallery-tabs">
          <button
            className={activeTab === "photos" ? "tab active" : "tab"}
            onClick={() => setActiveTab("photos")}
          >
            Photos
          </button>
          <button
            className={activeTab === "videos" ? "tab active" : "tab"}
            onClick={() => setActiveTab("videos")}
          >
            Videos
          </button>
        </div>

        {/* Photos */}
        {activeTab === "photos" && (
          <div className="gallery-grid">
            {photos.map((item, index) => (
              <div
                className="gallery-card"
                key={index}
                onClick={() => setSelectedImage(item.image)}
              >
                <img src={item.image} alt="Varanasi Gallery" />
              </div>
            ))}
          </div>
        )}

        {/* Videos */}
        {activeTab === "videos" && (
          <div className="video-grid">
            {videos.map((video, index) => (
              <div className="video-card" key={index}>
                <iframe
                  src={`https://www.youtube.com/embed/${video.videoId}`}
                  title={video.title}
                  allowFullScreen
                ></iframe>
                <p>{video.title}</p>
              </div>
            ))}
          </div>
        )}

        {/* Image Modal */}
        {selectedImage && (
          <div className="image-modal" onClick={() => setSelectedImage(null)}>
            <span className="close-btn">&times;</span>
            <img src={selectedImage} alt="Full View" />
          </div>
        )}

      </div>
    </section>
  );
};

export default Gallery;
